/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CursorPaginationDto } from '../../models/cursor-pagination-dto';

export interface CommunityCommentControllerSearchCursor$Params {
  communityId: string;

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 커서
 */
  cursor?: string;
}

export function communityCommentControllerSearchCursor(http: HttpClient, rootUrl: string, params: CommunityCommentControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
  const rb = new RequestBuilder(rootUrl, communityCommentControllerSearchCursor.PATH, 'get');
  if (params) {
    rb.path('communityId', params.communityId, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('cursor', params.cursor, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CursorPaginationDto>;
    })
  );
}

communityCommentControllerSearchCursor.PATH = '/api/community-comments/search/cursor/community/{communityId}';
